import { createContext, useState } from "react";

export const SignUpContext = createContext();

export const SignUpProvider = ({ children }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const [error, setError] = useState(null);

  const signup = async (data) => {
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/backend/users`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (!response.ok || !responseData.status) {
        // Handle both HTTP errors and API status=false cases
        const errorMessage = responseData.message || "Failed to register user";
        throw new Error(errorMessage);
      }

      // Return success response
      return {
        success: true,
        message: responseData.message,
        data: responseData.data
      };

    } catch (err) {
      setError(err.message);
      // Return error response
      return {
        success: false,
        message: err.message
      };
    }
  };

  return (
    <SignUpContext.Provider value={{ error, signup }}>
      {children}
    </SignUpContext.Provider>
  );
};